import { forwardRef } from 'react';
import HeadstoneAvatar from './headstone-avatar';
import CardInternal from './card-internal';
var Card = forwardRef(CardInternal);
var CardNamespace = Object.assign(Card, {
    HeadstoneAvatar: HeadstoneAvatar,
});
export default CardNamespace;
